import React, { useState, useCallback, useEffect } from "react";
import { useModal } from "react-modal-hook";
import { Formik, Form, Field } from "formik";
import { useSelector } from "react-redux";
import Modal from "../../../../components/Modal/Modal";
import InputError from "../../../../components/InputError/InputError";
import NeoOTP from "../../../../components/FormComponents/NeoOTP";
import NeoButton from "../../../../components/NeoButton/NeoButton";
import NeoInput from "../../../../components/NeoInput/NeoInput";
import NeoLoader from "../../../../components/FormComponents/NeoLoader";
import { useHistory } from "react-router-dom";
import { BlockDebitCardSchema } from "../../../../schemas/requests";
import RequestService from "../../../../services/request.service";
import {
  BLOCK_CARD_KEYS,
  BUTTON_KEYS,
} from "../../../../utils/translation-constants";
import { useTranslation } from "react-i18next";
import validationConfig from 'custom/config/validation.config.json'
import { NeoSuccess } from "../../../../components/FormComponents";
const blockCardConfig = validationConfig['blockCard']
import TermsAndCondition from "../../../../components/TermsAndConditions/TermsAndCondition";
import LayoutWithAccountCard from './../../../Layout/layout-account-card';
import { getCurrentAccDetailsSelector, getAccountListSelector } from "../../../../store/selectors/app.selector";
import AccountDisplay from "../../../../components/account-display/account-display";

export default function BlockDebitCard() {
  const { t } = useTranslation();
  const [otpEnabled, setOtpEnabled] = useState(false);
  const [stage, setStage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [message, setMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [verifyDetails, setVerifyDetails] = useState({})
  const accountList = useSelector(getAccountListSelector) || []
  const [cardList, setCardList]=useState([])
  const [branchList, setBranchList]=useState([])
  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector)
  const [loadingCards, setLoadingCards] = useState(false)


  const history = useHistory();

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className="modal-error-body">
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className="modal-btn-style">
            <NeoButton
              mode="newDesign"
              type="button"
              text={t(BUTTON_KEYS.CLOSE)}
              onClick={() => {
                hideModal();
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message]
  );


  const getCards = useCallback(async () => {
    try {
      setLoadingCards(true)
      const response = await RequestService.getCardList({ accountNumber: currentAccountDetail.accountNo })
      setCardList(response)
      setLoadingCards(false)
      if (response.length === 0) {
        setMessage('No Cards found attached to the account')
        showModal()
      }
    } catch (error) {
      setMessage(error)
      setLoadingCards(false)
    }
  }, [showModal])

  useEffect(() => {
      getCards()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();
      case 2:
        return renderConfirmation();
      case 3:
        return (
          <NeoOTP
            loading={loading}
            otp={otp}
            setOTP={setOtp}
            onSubmit={confirmBlockCard}
          />
        );
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return renderForm();
    }
  }


  const verifyBlockCard = useCallback(async (data, { setSubmitting }) => {
    try {
      setLoading(true)
      setSubmitting(true)
      setFormValues(data)
      let reqParams = {
        srcAccount: currentAccountDetail.accountNo,
        srcAccBranch: currentAccountDetail.brnCode,
        cardNo: data.cardNumber,
        remarks: data.remarks,
      }
      const response = await RequestService.blockDebitCardVerify(reqParams)
      if (response.status === 200) {
        setSubmitting(false)
        setVerifyDetails(response.data)
        setOtpEnabled(response.data['otpEnable'])
        setLoading(false)
        setStage(2)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const confirmBlockCard = useCallback(async () => {
    setLoading(true)
    try {
      let reqParams = {
        srcAccount: currentAccountDetail.accountNo,
        srcAccBranch: currentAccountDetail.brnCode,
        cardNo: formValues.cardNumber,
        otp,
        remarks: formValues.remarks,
        randomKey: verifyDetails.randomKey
      }
      const response = await RequestService.blockDebitCardConfirm(reqParams)
      setMessage(response.data['message'])
      setStage(4)
      setLoading(false)
    } catch (err) {
      setOtp('')
      setLoading(false)
    }
  }, [formValues, otp])

  function renderLoading() {
    return (
      <div className="mx-4 rounded d-flex justify-content-center align-items-center">
        <NeoLoader width="50px" height="50px" />
      </div>
    );
  }

  function renderForm() {
    return (
      <div>
        <div className="heading-style">{t(BLOCK_CARD_KEYS.BLOCK_CARD_TITLE)}</div>
        <Formik
          initialValues={{
            cardNumber: '',
            remarks: '',
          }}
          validationSchema={BlockDebitCardSchema}
          onSubmit={verifyBlockCard}
        >
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue, resetForm, setTouched  }) => (
            <Form>
            <div className='form-group'>
                <NeoInput
                  showAsterisk={blockCardConfig["isCardNoRequired"]}
                  mode='select'
                  text={t(BLOCK_CARD_KEYS.CARD_NUMBER)}
                  name='cardNumber'
                  disabled={loadingCards}
                  onChange={handleChange}
                  list={cardList}
                  keyValue='cardNo'
                />
                <InputError text={errors.cardNumber} touched={touched.cardNumber} />
              </div>
              <div className='form-group'>
                <NeoInput
                  showAsterisk={blockCardConfig["isRemarksRequired"]}
                  text={t(BLOCK_CARD_KEYS.REMARKS)}
                  disabled={loadingCards}
                  onChange={handleChange}
                  name='remarks'
                />
                <InputError text={errors.remarks} touched={touched.remarks} />
              </div>
              <div className='mt-5'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    mode='newDesign'
                    type='submit'
                    disabled={isSubmitting || loadingCards}
                    text={t(BUTTON_KEYS.SUBMIT)}
                  />
                )}
              </div>

              <div className='back-cancel-style' onClick={() => history.goBack()}>
                {t(BUTTON_KEYS.CANCEL)}
              </div>

            </Form>
          )}
        </Formik>
      </div>
    );
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
      <h3> {t(BLOCK_CARD_KEYS.BLOCK_CARD_CONFIRM_TITLE)}</h3>
      <AccountDisplay currentAccountDetail={currentAccountDetail} />

      <div>
        <h6 className='label'>{t(BLOCK_CARD_KEYS.CARD_NUMBER)}</h6>
        <h6 className='value'>{formValues.cardNumber}</h6>
      </div>
      <div>
        <h6 className='label'>{t(BLOCK_CARD_KEYS.REMARKS)}</h6>
        <h6 className='value'>{formValues.remarks}</h6>
      </div>
      <div className='mt-5'>
        {loading ? (
          renderLoading()
        ) : (
          <NeoButton
            mode={'newDesign'}
            type='button'
            className='btn btn-neo'
            text={t(BUTTON_KEYS.CONFIRM)}
            onClick={() => (otpEnabled ? setStage(3) : confirmBlockCard())}
          />
        )}
      </div>
      <div className='back-cancel-style' onClick={() => setStage(1)}>
      {t(BUTTON_KEYS.CANCEL)}
      </div>
    </div>
    );
  }

  return (
    <LayoutWithAccountCard showEmptySpace={true} breadCumKey="BLOCK_CARD" keyPath="DEBIT_BLOCK_CARD">
      <div className="new-design-form-style"> {renderSwitch()}</div>
    </LayoutWithAccountCard>
  );
}
